import RowClickable from './RowClickable'
import { formatNumberV2 } from '../utilities/Format'
import { format } from 'date-fns'
import Badge from '../components/Badge'
import { OrderStatusDisplay, OrderStatusTheme, EditSapMasterStatusDisplay } from '../constants/Enum'
import { isJson, parseBatchLots } from '../utilities/Validate'
import { OrderType } from '../models'

export const getOrderReadyColumns = () => {
	const pdOrderColumn = [
		{ key: 'id', name: 'เลข Order', width: 100, formatter: ({ row }) =>
			<div>
				<RowClickable value={row.id} endpoint="order-ready"/>
				{parseInt(row.releaseNo) > 1 ? ` (${parseInt(row.releaseNo)})` : null}
			</div>
		},
		{ key: 'materialDescription', name: 'คำอธิบาย Mat', minWidth: 150, 
			cellClass: 'leading-[normal] flex flex-col justify-center gap-1',
			formatter: ({ row }) => {
				return <>
					<p className='font-bold '>{row.materialDescription}</p>
					<p className='flex gap-1 text-muted'>
						{row.materialCode}
						{row.trialBatch && <p ><Badge variant={` text-[0.7rem] text-white bg-yellow-500`}>{row.trialBatch}</Badge></p>}
						{row.orderType && row.orderType === OrderType.REPACK && <p><Badge variant={` text-[0.7rem] text-white bg-blue-500`}>{row.orderType}{row.alternativeText ? ` - ${row.alternativeText}` : ''}</Badge></p>}
						{row.orderType && row.orderType === OrderType.CLAIM && <p><Badge variant={` text-[0.7rem] text-white bg-red-500`}>{row.orderType}{row.alternativeText ? ` - ${row.alternativeText}` : ''}</Badge></p>}
					</p>
				</>
			}
		},
		{ key: 'batchNumbers', name: 'Batch no.', width: 105, formatter: ({ row }) => {
			const lots = row.actualBatchNumbers ? parseBatchLots(row.actualBatchNumbers) : parseBatchLots(row.batchNumbers)
			return <div className='space-y-1'>
				{lots.map(lot => <p key={lot}><Badge variant={` text-xs text-white bg-green-600`}>{lot}</Badge></p>)}
			</div>
		}, cellClass: "multi-line-row-data-grid" },
		{ key: 'orderQty', name: 'จำนวน', width: 85, formatter: ({ row }) =>
			<div className="text-right">{formatNumberV2(row.orderQty)}<span className='ml-1 text-xs text-muted'>{row.materialUnit}</span></div>
		},
		{ key: 'dueDate', name: 'วันผลิต', width: 95 },
		{ key: 'statusFromApp', name: "สถานะ", width: 100, formatter: ({ row }) =>
			<Badge variant={OrderStatusTheme[row.statusFromApp]}>{OrderStatusDisplay[row.statusFromApp]}</Badge>
		},
		// { key: 'note', name: 'หมายเหตุ', width: 100, cellClass: 'overflow-scroll text-clip', formatter: ({ row }) => {
		{ key: 'note', name: 'หมายเหตุ', width: 120, formatter: ({ row }) => {
			return (
				<>
					{ row.tags && isJson(row.tags) && Array.isArray(JSON.parse(row.tags)) ? 
						JSON.parse(row.tags).map((tag, index) => <Badge key={`tag-${index}`} variant='tags !p-1 text-white bg-yellow-500 text-xs'>{tag === 'EXTRA' ? 'เบิกเพิ่ม':tag}</Badge>)
							: row.tags && isJson(row.tags) ? <Badge variant='tags !p-1 text-white bg-yellow-500 text-xs'>{JSON.parse(row.tags)}</Badge>
								: row.tags && Array.isArray(row.tags) ? row.tags.map((tag, index) => <Badge key={`tag-${index}`} variant='tags !p-1 text-white bg-yellow-500 text-xs'>{tag === 'EXTRA' ? 'เบิกเพิ่ม':tag}</Badge>)
									: row.tags ? <Badge variant='tags !p-1 text-white bg-yellow-500 text-xs'>{row.tags}</Badge>
										: <></>
					}
				</>
			)},
			cellClass: 'leading-[normal] flex flex-row flex-wrap items-center gap-1'
		}
	];
	return pdOrderColumn
}

export const getOrderWaitConfirmColumns = () => {
	const pdOrderColumn = [
		{ key: 'id', name: 'เลข Order', width: 90, formatter: ({ row }) =>
				<RowClickable value={row.id} endpoint="order-wait-confirm"/> },
		{ key: 'materialDescription', name: 'คำอธิบาย', minWidth: 220,
			cellClass: 'leading-[normal] flex flex-col justify-center gap-1',
			formatter: ({ row }) => 
				<>
					<p className='font-bold '>{row.materialDescription}</p>
					<p className='flex gap-1 text-muted'>
						{row.materialCode}
						{row.trialBatch && <p ><Badge variant={` text-[0.7rem] text-white bg-yellow-500`}>{row.trialBatch}</Badge></p>}
						{row.orderType && row.orderType === OrderType.REPACK && <p><Badge variant={` text-[0.7rem] text-white bg-blue-500`}>{row.orderType}{row.alternativeText ? ` - ${row.alternativeText}` : ''}</Badge></p>}
            {row.orderType && row.orderType === OrderType.CLAIM && <p><Badge variant={` text-[0.7rem] text-white bg-red-500`}>{row.orderType}{row.alternativeText ? ` - ${row.alternativeText}` : ''}</Badge></p>}
					</p>
				</>
		},
		{ key: 'batchNumbers', name: 'Batch no.', width: 105, formatter: ({ row }) => {
			const lots = row.actualBatchNumbers ? parseBatchLots(row.actualBatchNumbers) : parseBatchLots(row.batchNumbers)
			return <div className='space-y-1'>
				{lots.map(lot => <p key={lot}><Badge variant={` text-xs text-white bg-green-600`}>{lot}</Badge></p>)}
			</div>
		}, cellClass: "multi-line-row-data-grid" },
		{ key: 'materialUnit', name: 'จำนวน', width: 80,
			cellClass: ' flex gap-1 justify-end', 
			formatter: ({ row }) => 
				<>
					<span>{formatNumberV2(row.orderQty)}</span>
					<span className='text-[0.7rem] text-muted'>{row.materialUnit}</span>
				</>
		},
		{ key: 'dueDate', name: 'วันผลิต', width: 95 },
		{ key: 'actualDueDate', name: 'วันผลิตจริง', width: 95, formatter: ({ row }) =>
			<div>{row.actualDueDate ? format(new Date(row.actualDueDate), 'dd/MM/yyyy') : ''}</div> },
		{ key: 'updatedAt', width: 130, name: 'แก้ไขล่าสุด', formatter: ({ row }) =>
			<div>{format(new Date(row.updatedAt), 'dd/MM/yyyy HH:mm')}</div> },
		{ key: 'countEditWorkCenter', width: 80, name: "แก้ที่ SAP", formatter: ({ row }) => {
			if (!row.countEditWorkCenter && !row.countEditOperation) return ''
			return (
				<div>{`
					${row.countEditWorkCenter && row.countEditWorkCenter > 0 ? EditSapMasterStatusDisplay.EDIT_WC : ''},${row.countEditOperation && row.countEditOperation > 0 ? EditSapMasterStatusDisplay.EDIT_OPERATION : ''}
				`}</div>)
		}},
		{ key: 'statusFromApp', name: "สถานะ", width: 100, formatter: ({ row }) =>
			<Badge variant={OrderStatusTheme[row.statusFromApp]}>{OrderStatusDisplay[row.statusFromApp]}</Badge>
		},
		// { key: 'note', name: 'หมายเหตุ', width: 180, cellClass: 'overflow-scroll text-clip', formatter: ({ row }) => {
		{ key: 'note', name: 'หมายเหตุ', width: 180, formatter: ({ row }) => {
			return (
				<>
					{ row.tags && isJson(row.tags) && Array.isArray(JSON.parse(row.tags)) ? 
						JSON.parse(row.tags).map((tag, index) => <Badge key={`tag-${index}`} variant='tags !p-1 text-white bg-yellow-500 text-xs'>{tag === 'EXTRA' ? 'เบิกเพิ่ม':tag}</Badge>)
							: row.tags && isJson(row.tags) ? <Badge variant='tags !p-1 text-white bg-yellow-500 text-xs'>{JSON.parse(row.tags)}</Badge>
								: row.tags ? <Badge variant='tags !p-1 text-white bg-yellow-500 text-xs'>{row.tags}</Badge>
								: <></>
					}
				</>
			)},
			cellClass: 'leading-[normal] flex flex-row flex-wrap items-center gap-1'
		}
	];
	return pdOrderColumn.map(col => {
		return {
			...col, sortDescendingFirst: true, sortable: true
		}
	})
}